import * as React from "react";
import Box from "@mui/material/Box";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useQueryClient } from "@tanstack/react-query";
import { updateWorkflowStep } from "../../services/apiCards";
import "./ChangeStatus.scss";
import { useWorkflowById } from "../../reactQuery/workflows";
import CustomMenuItem from "../Menu/CustomMenuItem";
import { CustomButton } from "../Button/Button";
import { useCallback, useMemo } from "react";
import useMutate from "../../hooks/useMutate";

function ChangeStatus({
  boardId,
  checkCondition,
  workflow_id,
  cardId,
  workflowStepId,
  listView = false,
  boardPermission,
  currentUser
}) {
  const [status, setStatus] = React.useState("");
  const [cachedData, setCachedData] = React.useState("");
  const queryClient = useQueryClient();
  const { data: workflows } = useWorkflowById(workflow_id, boardId);

  React.useEffect(() => {
    if (boardId && workflows) {
      setCachedData(workflows);
    }
  }, [boardId, workflows]);

  React.useEffect(() => {
    setStatus(workflowStepId);
  }, [workflowStepId]);

  const { mutate: updateMutate } = useMutate(updateWorkflowStep,[],
    ()=>{},
    () => {
      queryClient.invalidateQueries({
        queryKey: [`cards`, String(boardId)],
      });

      queryClient.invalidateQueries({
        queryKey: [`history`, String(cardId)],
      });
      queryClient.invalidateQueries({
        queryKey: [`card`, String(cardId)],
      });
      //toast.success(res.data.message);
    },
    () => {
      setStatus(workflowStepId);
    },
  );

  const handleChange = useCallback((event) => {
    updateMutate({
      card_id: cardId,
      workflow_step_id: event.target.value,
    });
    setStatus(event.target.value);
  }, [cardId, updateMutate]);


  const showStatus = useMemo(() => {
    return (
      cachedData &&
      cachedData?.data?.data?.responseData?.filter(
        (workflow) => workflow.workflow_step_id == status
      )[0]
    );
  }, [cachedData, status]);

  return (
    <Box className={listView ? "project-status-cell list-view" : "project-status-cell"}>
      {checkCondition &&(boardPermission?.can_update_status && currentUser?.user_id == cardId?.data?.data?.responseData?.assigned_to_user_id) ? (
        <FormControl size="small" className="card-status-dropdown-parent">
          <Select
            labelId="demo-simple-select-label"
            value={showStatus && status}
            onChange={handleChange}
            className="card-status-dropdown"
          >
            {cachedData &&
              cachedData?.data?.data?.totalRecord &&
              cachedData?.data?.data?.responseData
                ?.sort((a, b) => a.step_sequence - b.step_sequence)
                .map((workflow, index) => (
                  <CustomMenuItem
                    value={workflow.workflow_step_id}
                    className="uppercase"
                    key={`changeStatus-${workflow.workflow_step_id}`}
                  >
                    {workflow.status}
                  </CustomMenuItem>
                ))}
          </Select>
        </FormControl>
      ) : (
        <div className="project-status d-inline-flex justify-content-center align-items-center">
          <CustomButton
            className="project-status-button"
            title={listView ? showStatus?.status || "" : undefined}
          >
            <span className="project-status-text">
              {showStatus && showStatus?.status}
            </span>
          </CustomButton>
          <div className="project-status-icon">
            {/* <KeyboardArrowDownIcon/> */}
          </div>
        </div>
      )}
    </Box>
  );
}

export default React.memo(ChangeStatus);
